import { connect } from 'react-redux';

import Row from 'components/UIKit/Flex/Row';
import Column from 'components/UIKit/Flex/Column';
import style from 'components/Upload/style';
import SubmitDisclaimer from 'components/Disclaimers/SubmitDisclaimer';
import ButtonTemplate from 'components/UIKit/Button/ButtonTemplate';
import { Checkbox } from 'components/forms';
import InternalLink from 'components/Links/InternalLink';
import { SECONDARY_RED } from 'style/colors';

const BlockedInstruction = ({
  closeModal,
  criticalCount,
  pending,
  warningCount,
}) => (
  <section style={{ padding: '0 4rem' }}>
    {[
      (criticalCount > 0 || warningCount > 0) && (
        <p>
          {criticalCount > 0
            ? (
              <span>
                <strong>
                  <span style={{ color: SECONDARY_RED }}>
                    {`Please resolve ${criticalCount} CRITICAL errors `}
                  </span>
                  {warningCount > 0 && `and review ${warningCount} warnings `}
                </strong>
                {'in your project\'s '}
              </span>
            )
            : warningCount > 0 && (
              <span>
                {`Please review ${warningCount} warnings in your project's `}
              </span>
            )}

          <InternalLink
            onClick={closeModal}
            to="qc"
            withProjectPath
            >
            QC Report
          </InternalLink>

          <span>
            {' before submitting validated data to the GDC.'}
          </span>
        </p>
      ),
      pending && (
        <p style={{ fontWeight: 'bold' }}>
          {'You cannot submit data for harmonization because your project has QC checks pending.  Please try again after the next QC run has completed.'}
        </p>
      ),
    ]}
  </section>
);

class Submission extends React.Component {
  state = {
    warningCheckbox: false,
  };

  onClickSubmit = (handleOnClick, closeModal) => {
    handleOnClick().then(() => closeModal());
  }

  isDisabled = ({
    criticalCount,
    isFetching,
    pending,
    status,
    warningCheckbox,
    warningCount,
  }) => isFetching
    || criticalCount > 0
    || (warningCount > 0 && !warningCheckbox)
    || pending
    || !(!pending && status === 'SUCCESS')

  render() {
    const {
      closeModal,
      params: { program, project },
      handleOnClick,
      qcErrors: {
        data: {
          CRITICAL: criticalCount,
          WARNING: warningCount,
        },
      },
      qcStatus: {
        isFetching,
        pending,
        status,
      },
    } = this.props;
    const { warningCheckbox } = this.state;

    return (
      <div style={{ height: '100%' }}>
        <Row
          style={{
            ...style.wizardHeader,
            justifyContent: 'space-between',
          }}
          >
          <span
            style={{
              ...style.wizardNavItem,
              padding: '0 1rem',
              textTransform: 'uppercase',
            }}
            >
            {`submit ${program}-${project} data to GDC`}
          </span>
          <a
            onClick={closeModal}
            style={{
              zIndex: 20,
              padding: '0 1rem',
              textDecoration: 'none',
              fontSize: '1em',
              fontWeight: 'bold',
              cursor: 'pointer',
              color: 'rgb(66, 66, 66)',
            }}
            >
             CANCEL &#10005;
          </a>
        </Row>

        <div style={{ height: 'calc(100% - 1.8rem)' }}>
          <Column
            style={{
              height: '100%',
              width: '90%',
              margin: '0 auto',
              boxSizing: 'border-box',
              padding: '1rem 1rem',
              alignItems: 'center',
            }}
            >
            <SubmitDisclaimer />

            {(criticalCount > 0 || pending)
              ? (
                <BlockedInstruction
                  closeModal={closeModal}
                  criticalCount={criticalCount}
                  pending={pending}
                  warningCount={warningCount}
                  />
              )
              : warningCount > 0 && (
                <Checkbox
                  checked={warningCheckbox}
                  disabled={false}
                  labelText={(
                    <span>
                      {`There are ${warningCount} warnings outstanding in my project. I have reviewed the project's `}
                      <InternalLink
                        onClick={closeModal}
                        to="qc"
                        >
                        QC Report
                      </InternalLink>
                      {'.'}
                    </span>
                  )}
                  onChange={() => this.setState({ warningCheckbox: !warningCheckbox })}
                  />
              )}

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              >
              <ButtonTemplate
                disabled={this.isDisabled({
                  criticalCount,
                  isFetching,
                  pending,
                  status,
                  warningCheckbox,
                  warningCount,
                })}
                onClick={() => this.onClickSubmit(handleOnClick, closeModal)}
                style={{ margin: '1.5rem', padding: '0.7rem' }}
                >
                Submit validated data to the GDC
              </ButtonTemplate>
            </div>
          </Column>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    projects: state.projects.items,
    qcStatus: state.qcReports.statusData,
    workflow: state.workflow,
  }),
)(Submission);
